'use client';

import * as React from 'react';
import { LanguagePicker as UILanguagePicker } from '~ui/components/LanguagePicker/LanguagePicker';
import { Text } from '~ui/components/typography/Text/Text';
import { useResolvedCompanyCtx } from '../../../contexts/ResolvedCompanyContext/ResolvedCompanyProvider';
import { useWaiterRouter } from '../hooks/useWaiterRouter';
import { jsx as _jsx } from "react/jsx-runtime";
export var LanguagePicker = function LanguagePicker() {
  var _useResolvedCompanyCt = useResolvedCompanyCtx(),
      availableLanguages = _useResolvedCompanyCt.availableLanguages,
      selectedLanguage = _useResolvedCompanyCt.selectedLanguage,
      hasMultipleLanguages = _useResolvedCompanyCt.hasMultipleLanguages;

  var router = useWaiterRouter();
  var changeLocale = React.useCallback(function (newLocale) {
    router.changeLocale(newLocale.code);
  }, [router]);

  if (!hasMultipleLanguages) {
    return null;
  }

  return /*#__PURE__*/_jsx(UILanguagePicker, {
    variant: "popover",
    idPropKey: "code",
    onSelect: changeLocale,
    languages: availableLanguages,
    selectLabel: selectedLanguage.name,
    renderLanguage: function renderLanguage(language) {
      return /*#__PURE__*/_jsx(Text, {
        fontStyle: "regular",
        contrast: "low",
        children: language.name
      });
    }
  });
};